import { ISummary, ISummaryStory } from 'store/ticket-service/types';

import { GeneralStepConversationTopics } from 'core/enums/common';

export const getIsActiveTicketHasEmptyScenariosOrCriteria = (
	activeTicketSummaries: ISummary | undefined,
	param: keyof Pick<ISummaryStory, 'summaryAcceptanceCriteria' | 'summaryScenarios'>,
	activeSubStage?: GeneralStepConversationTopics
): boolean => {
	if (!activeTicketSummaries) return false;

	const hasEmptyStoriesWithParam = activeTicketSummaries?.some((ticket) => {
		const paramLength = ticket?.[param]?.length || 0;

		const hasActiveSubStage = activeSubStage ? ticket.subStage === activeSubStage : true;

		return hasActiveSubStage && !paramLength;
	});

	return hasEmptyStoriesWithParam;
};
